/**
 * Shared events data.
 * Both HomePage and EventsPage import from here so the data stays in sync.
 *
 * Each event object accepts:
 *   id        {string}  – URL-safe slug (used as the anchor on EventsPage)
 *   month     {string}  – Display month (e.g. 'May')
 *   day       {string}  – Display day or 'TBA'
 *   year      {string}  – Four-digit year
 *   title     {string}  – Event title
 *   details   {string}  – Short one-line description (shown on HomePage)
 *   location  {string}  – Venue / address
 *   time      {string}  – Time string, e.g. '10 am – 2 pm'  (optional)
 *   rainDate  {string}  - Rain date note (optional)
 *   description {string} – Longer paragraph shown only on EventsPage (optional)
 *   image     {string}  – Imported image URL (optional)
 *   pdfUrl    {string}  - Imported or public PDF URL for event flyer/details (optional)
 *   pdfLabel  {string}  - Accessible label for the PDF link (optional)
 */

import springPlantSalePdf from '../images/SpringPlantSale.pdf';

const MONTHS = {
  Jan: 0,
  January: 0,
  Feb: 1,
  February: 1,
  Mar: 2,
  March: 2,
  Apr: 3,
  April: 3,
  May: 4,
  Jun: 5,
  June: 5,
  Jul: 6,
  July: 6,
  Aug: 7,
  August: 7,
  Sep: 8,
  Sept: 8,
  September: 8,
  Oct: 9,
  October: 9,
  Nov: 10,
  November: 10,
  Dec: 11,
  December: 11,
};

const rawEvents = [
  {
    id: 'plant-sale-2026',
    month: 'May',
    day: '16',
    year: '2026',
    title: 'Spring Plant Sale',
    details: 'Saturday, May 16th, 10 AM - 2 PM. Rain date May 17th.',
    location: '1414 N Hancock St',
    time: '10 AM - 2 PM',
    rainDate: 'Rain date May 17th',
    description:
      "Join us for a spring plant sale that raises money to support Emma's Court Community Garden. Shop native and non-native perennial flowers, annual flowers, vegetable starts, and a lively assortment of house plants.",
    pdfUrl: springPlantSalePdf,
    pdfLabel: 'Spring Plant Sale PDF',
  },
];

function parseEventDate(evt) {
  if (!evt || !evt.day) return null;
  const dayStr = String(evt.day).trim();
  if (!dayStr || dayStr.toLowerCase() === 'tba') return null;
  const year = Number(evt.year) || new Date().getFullYear();
  const monthName = evt.month;
  const monthIndex = MONTHS[monthName] ?? MONTHS[String(monthName).slice(0, 3)];
  const day = Number(dayStr);
  if (Number.isNaN(day) || monthIndex == null) return null;
  const d = new Date(year, monthIndex, day);
  d.setHours(0, 0, 0, 0);
  return d;
}

const startOfToday = new Date();
startOfToday.setHours(0, 0, 0, 0);

export const upcomingEvents = [];
export const pastEvents = [];

rawEvents.forEach((evt) => {
  const eventDate = parseEventDate(evt);
  if (eventDate && eventDate < startOfToday) {
    pastEvents.push(evt);
  } else {
    upcomingEvents.push(evt);
  }
});

